/**
 * custom.js
 *
 * Custom JavaScript (jQuery) code for the Application.
 */

/**
 * Executes the JavaScript code when the DOM is ready to be used.
 * By passing the $ you can code using the $ alias for jQuery.
 * Inside of this function, $() will work as an alias for jQuery()
 * and other libraries also using $ will not be accessible under this shortcut
 */
( function($) {

	// Initialize the Foundation JavaScript
	// Documentation can be found at: http://foundation.zurb.com/docs
	Foundation.Drilldown.defaults.backButton = '<li class="js-drilldown-back"><a>Back</a></li>';
	$(document).foundation();


	// Add "sticky" class to site header
	if( $( document ).scrollTop() > 0 ){
		$( '.site-header' ).addClass( 'sticky' );			
	}
	$( document ).on('scroll', function(){
		if ( $( document ).scrollTop() > 0 ){
			$( '.site-header' ).addClass( 'sticky' );			
		} else {
			$( '.site-header' ).removeClass( 'sticky' );			
		}
	});



} )(jQuery);
